import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    question: 'Quels types de fenêtres réparez-vous ?',
    answer: 'Nous intervenons sur tous types de fenêtres : PVC, aluminium, bois, double vitrage, simple vitrage, baies vitrées, fenêtres oscillo-battantes, etc. Notre expertise couvre l\'ensemble des menuiseries modernes et anciennes.'
  },
  {
    question: 'Quel est le délai d\'intervention pour un dépannage urgent ?',
    answer: 'Pour les urgences (vitre cassée, problème de sécurité), nous intervenons sous 24h, 7j/7. Pour les réparations standard, le délai est généralement de 2 à 3 jours ouvrés selon la disponibilité.'
  },
  {
    question: 'Proposez-vous un devis gratuit ?',
    answer: 'Oui, nous proposons systématiquement un devis gratuit et sans engagement. Un de nos techniciens se déplace pour évaluer vos besoins et vous fournir une estimation détaillée des travaux à réaliser.'
  },
  {
    question: 'Vos réparations sont-elles garanties ?',
    answer: 'Absolument. Toutes nos interventions sont garanties 2 ans, pièces et main d\'œuvre. Nous utilisons uniquement des matériaux de qualité professionnelle pour assurer la durabilité de nos réparations.'
  },
  {
    question: 'Intervenez-vous pour les particuliers et les professionnels ?',
    answer: 'Oui, nous travaillons aussi bien avec des particuliers qu\'avec des professionnels (syndics, entreprises, commerces). Nous adaptons nos services et nos horaires d\'intervention selon vos besoins.'
  },
  {
    question: 'Quels sont vos tarifs pour une réparation de fenêtre ?',
    answer: 'Nos tarifs varient selon le type d\'intervention : remplacement de vitrage, changement de joints, réglage de mécanisme, etc. Comptez à partir de 80€ pour une intervention simple. Le devis précis est établi après diagnostic.'
  },
  {
    question: 'Puis-je améliorer l\'isolation de mes fenêtres existantes ?',
    answer: 'Oui, plusieurs solutions existent : remplacement des joints, installation de survitrage, changement pour du double vitrage. Nous vous conseillons la solution la plus adaptée à votre budget et vos besoins en isolation thermique et phonique.'
  },
  {
    question: 'Acceptez-vous les paiements en plusieurs fois ?',
    answer: 'Pour les travaux importants, nous proposons des facilités de paiement. Nous acceptons les règlements par chèque, virement bancaire et carte bancaire. Contactez-nous pour discuter des modalités.'
  }
];

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-teal/10 text-teal px-6 py-2 rounded-full text-sm font-semibold mb-6">
            QUESTIONS FRÉQUENTES
          </div>
          <h2 className="text-5xl font-bold text-gray-900">
            Tout Savoir sur Nos Services
          </h2>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className={`bg-gray-50 rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'border-l-4 border-teal' : ''
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-100 transition-colors"
              >
                <h3 className="text-xl font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <motion.div
                  animate={{ rotate: openIndex === index ? 45 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="flex-shrink-0 w-8 h-8 flex items-center justify-center"
                >
                  <i className="ri-add-line text-2xl text-orange"></i>
                </motion.div>
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-8 pb-6 pt-2">
                      <p className="text-gray-700 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}